import AutenticacaoService from '../services/autenticacao.service'
import AutenticacaoLocalStorage from '../localstorage/autenticacao.localstorage'
import { TOKEN_ADICIONAR, TOKEN_REMOVER, TOKEN_VALIDO } from './mutationsTypes'

export default {
  namespaced: true,
  state: {
    userObj: AutenticacaoLocalStorage.getUserObj(),
    autenticado: AutenticacaoLocalStorage.getUserObj() !== '',
  },

  // Adicionado comandos para ignorar linhas no eslint
  // Usado apenas para as mutations do Vuex
  mutations: {
    [TOKEN_ADICIONAR](state, payload) {
      // eslint-disable-next-line
      state.userObj = payload
      // eslint-disable-next-line
      state.autenticado = true
    },
    [TOKEN_REMOVER](state) {
      // eslint-disable-next-line
      state.userObj = '';
      // eslint-disable-next-line
      state.autenticado = false
    },
    [TOKEN_VALIDO](state) {
      // eslint-disable-next-line
      state.autenticado = true
    },
  },

  actions: {
    async realizaLoginStore({ commit }, objDados) {
      try {
        const retornoApi = await AutenticacaoService.login(objDados)
        const userObj = retornoApi.data
        commit(TOKEN_ADICIONAR, userObj)
        AutenticacaoLocalStorage.setUserObj(userObj);

        return retornoApi
      } catch (error) {
        throw error
      }
    },

    async verificaTokenStore({ commit }, token) {
      try {
        const retornoApi = AutenticacaoService.validaToken(token)
        commit(TOKEN_VALIDO)
        AutenticacaoLocalStorage.adicionaAuthorization(token)

        return retornoApi
      } catch (error) {
        commit(TOKEN_REMOVER);
        AutenticacaoLocalStorage.removeUserObj()

        throw error
      }
    },
    sairDoSistemaStore({ commit }) {
      commit(TOKEN_REMOVER)
      AutenticacaoLocalStorage.removeUserObj();
    },
  },

  getters: {
    userObj: state => state.userObj,
    autenticado: state => state.autenticado,
  },
}
